import { render } from "./VendorsTable.vue?vue&type=template&id=7753f2e6"
import script from "./VendorsTable.vue?vue&type=script&lang=ts"
export * from "./VendorsTable.vue?vue&type=script&lang=ts"

import "./VendorsTable.vue?vue&type=style&index=0&id=7753f2e6&lang=scss"
script.render = render

export default script